// Layout.jsx
import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import ControlPlaneSidebar from './ControlPlaneSidebar';
import { useControlPlane } from '../controlPlane/ControlPlaneProvider';
import globalMenuConfig from '../menu/menuConfig';
import '../App.css';

const LS_SIDEBAR_OPEN = 'ui.sidebarOpen';

function getInitialSidebarOpen() {
  try {
    const v = localStorage.getItem(LS_SIDEBAR_OPEN);
    if (v !== null) return v === '1';
  } catch {}
  // Default: open on desktop, closed on mobile
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 1024;
  }
  return false;
}

export default function Layout({ children }) {
  const { enabled, loading, error, retry } = useControlPlane();
  const [isSidebarOpen, setSidebarOpen] = useState(getInitialSidebarOpen);
  const [menuConfig, setMenuConfig] = useState(globalMenuConfig);

  // persist on change
  useEffect(() => {
    try { localStorage.setItem(LS_SIDEBAR_OPEN, isSidebarOpen ? '1' : '0'); } catch {}
  }, [isSidebarOpen]);

  return (
    // 🔒 lock the page height and hide body scroll
    <div
      className="page-container"
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Header toggleSidebar={() => setSidebarOpen((o) => !o)} />

      {/* flex row with no extra scrollbars */}
      <div
        className="layout"
        style={{
          flex: 1,
          minHeight: 0,            // ⬅️ allow children to shrink and scroll
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        {!loading && !error && enabled === true ? <ControlPlaneSidebar
          isOpen={isSidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
        /> : !loading && !error && enabled === false ? <Sidebar
          isOpen={isSidebarOpen}
          menuConfig={menuConfig}
          setMenuConfig={setMenuConfig}
          closeSidebar={() => setSidebarOpen(false)}
        /> : <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`} aria-label="Navigation status">
          {error ? <div role="alert"><p>{error}</p><button type="button" onClick={retry}>Retry</button></div>
            : <p role="status">Loading navigation...</p>}
        </aside>}

        {/* ✅ only THIS scrolls */}
        <main
          className="content"

        >
          {React.cloneElement(children, { setMenuConfig, isSidebarOpen })}
        </main>
      </div>
    </div>
  );
}
